import { Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { readDisplayConditionsGroup } from './display-conditions.model';

export type EditorShellTab = 'settings' | 'display-conditions';

@Component({
  selector: 'smart-cart-form-editor-shell',
  templateUrl: './smart-cart-form-editor-shell.component.html',
  standalone: false,
})
export class SmartCartFormEditorShellComponent {
  @Input({ required: true }) formGroup!: AbstractControl;
  @Input() settingsLabel = 'Settings';

  activeTab: EditorShellTab = 'settings';

  get displayConditionsGroup(): UntypedFormGroup | null {
    return readDisplayConditionsGroup(this.formGroup);
  }

  onTabChange(tab: EditorShellTab): void {
    this.activeTab = tab;
  }
}
